module.exports = __webpack_public_path__ + "static/media/headImg.03cf03d8.png";